import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { N20 } from '@atlaskit/adf-schema';
import Select from '@atlaskit/select';
import { DisplayMode } from '../../RenderForm';
import { ViewWrapper } from '../common/questionWrappers';
import { ViewOtherOption } from './ViewOtherOption';
var styles = {
  control: function control(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      backgroundColor: "var(--ds-background-accent-gray-subtlest, ".concat(N20, ")"),
      borderColor: "var(--ds-border-disabled, #DFE1E6)",
      color: "var(--ds-text, #172B4D !important)"
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: "var(--ds-text, #172B4D)"
    });
  }
};
export var ViewDropdownMultiselect = function ViewDropdownMultiselect(_ref) {
  var id = _ref.id,
    value = _ref.value,
    options = _ref.options,
    hasOtherOption = _ref.hasOtherOption,
    otherOptionText = _ref.otherOptionText,
    displayMode = _ref.displayMode;
  // if the user has selected 'Other...' and provided a value we display that value. Otherwise we display 'Other...'
  var labels = value && value.map(function (item) {
    return item.label;
  });
  if (labels && hasOtherOption && otherOptionText) {
    labels.push(otherOptionText);
    // the actual 'Other...' option will always be the last one in the array, we do not display this in view mode
    // it is the last one in case the user added their own option that is also called 'Other...'
    var lastIndex = labels.lastIndexOf('Other...');
    if (lastIndex !== -1) {
      labels.splice(lastIndex, 1);
    }
  }
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    // This is a Disabled Select
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, {
      id: id,
      options: options,
      value: value,
      isMulti: true,
      placeholder: "",
      isDisabled: true,
      styles: styles
    }), /*#__PURE__*/React.createElement(ViewOtherOption, {
      dropdown: true,
      display: hasOtherOption,
      value: otherOptionText
    }));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, labels && labels.join(', '));
};